/**
 * Get the footer from API
 * @param {object} state - The vuex state object
 * @return {object[]} A array of footer
 */
export const getFooter = (state) => {
  return Array.isArray(state.footer) ? state.footer : null
};
